import {
  ChakraBox,
  ChakraFlex,
  FAIconName,
  SkeletonLoader,
  ToastMessage,
} from '@equip.health/ui';
import { useEffect, useState } from 'react';

import Header from '~/components/common/Header';
import { PRESCRIPTION_MESSAGES_LOAD_ERROR_MESSAGE } from '~/components/maud/prescriptions/prescriptions.constants';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';
import {
  useGetScriptSurePrescriptionMessagesCountQuery,
  useGetScriptSurePrescriptionMessagesURLQuery,
} from '~/store/services/integration';

const TOP_LEVEL_ID = 'prescriptions';

const Prescriptions = () => {
  const [isIframeLoaded, setIsIframeLoaded] = useState<boolean>(false);

  const {
    currentData: prescriptionMessages,
    error,
    isFetching,
  } = useGetScriptSurePrescriptionMessagesURLQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useGetScriptSurePrescriptionMessagesCountQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    setIsIframeLoaded(false);
  }, [prescriptionMessages?.url]);

  const isLoaded =
    isIframeLoaded || !!error || (!isFetching && !prescriptionMessages?.url);

  return (
    <ChakraFlex
      direction="column"
      height="100%"
      paddingBottom={PAGE_LAYOUT.bottomSpacing}
      paddingRight={PAGE_LAYOUT.rightSpacing}
      paddingTop={PAGE_TOP_PADDING}
    >
      <Header title="Prescriptions" />

      <ChakraBox flex="1" minHeight={0} mt="10px" position="relative">
        {!isLoaded && (
          <ChakraBox inset={0} position="absolute">
            <SkeletonLoader id={`${TOP_LEVEL_ID}-skeleton`} height="100%" />
          </ChakraBox>
        )}

        {error && (
          <ToastMessage
            id={`${TOP_LEVEL_ID}-message-error`}
            icon={FAIconName.exclamationTriangleRegular}
            isFullWidth
            text={PRESCRIPTION_MESSAGES_LOAD_ERROR_MESSAGE}
            variant="critical"
          />
        )}

        {prescriptionMessages?.url && (
          <ChakraBox
            h="100%"
            visibility={isIframeLoaded ? 'visible' : 'hidden'}
          >
            <iframe
              allowFullScreen
              data-testid="prescription-messages"
              src={prescriptionMessages.url}
              title="prescription-messages"
              onLoad={() => setIsIframeLoaded(true)}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </ChakraBox>
        )}
      </ChakraBox>
    </ChakraFlex>
  );
};

export default Prescriptions;
